// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-button {
  background-color: #28a745;
  color: white;
  margin-left: 0.5rem;
  border-radius: 4px;
}

  .add-button:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }

:host ::ng-deep .add-button .p-button {
  background-color: #28a745 !important;
  color: white !important;
  border-color: #28a745 !important;
  height: 30px !important;
  margin-left: 0.5rem;
}

  :host ::ng-deep .add-button .p-button:hover {
    background-color: #218838 !important;
    border-color: #1e7e34 !important;
  }

::ng-deep .export-button .p-button {
  background-color: #0094ff !important;
  color: white !important;
  border-color: #0094ff !important;
}

.tableGridWrap {
  position: relative;
  width: 100%;
}

a {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

  a:hover {
    color: #0056b3;
    text-decoration: underline;
  }

.container-fluid {
  padding-right: 15px;
  padding-left: 15px;
}

.section {
  background: white;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .container-fluid {
    padding-right: 10px;
    padding-left: 10px;
  }

  .section {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/group-member/group-member.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;EAEE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;AAEF;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;;EAEE;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;AAEF;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;EAEE;IACE,cAAc;IACd,0BAA0B;EAC5B;;AAEF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".add-button {\r\n  background-color: #28a745;\r\n  color: white;\r\n  margin-left: 0.5rem;\r\n  border-radius: 4px;\r\n}\r\n\r\n  .add-button:hover {\r\n    background-color: #218838;\r\n    border-color: #1e7e34;\r\n  }\r\n\r\n:host ::ng-deep .add-button .p-button {\r\n  background-color: #28a745 !important;\r\n  color: white !important;\r\n  border-color: #28a745 !important;\r\n  height: 30px !important;\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n  :host ::ng-deep .add-button .p-button:hover {\r\n    background-color: #218838 !important;\r\n    border-color: #1e7e34 !important;\r\n  }\r\n\r\n::ng-deep .export-button .p-button {\r\n  background-color: #0094ff !important;\r\n  color: white !important;\r\n  border-color: #0094ff !important;\r\n}\r\n\r\n.tableGridWrap {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\na {\r\n  color: #007bff;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n  a:hover {\r\n    color: #0056b3;\r\n    text-decoration: underline;\r\n  }\r\n\r\n.container-fluid {\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.section {\r\n  background: white;\r\n  border-radius: 4px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .container-fluid {\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .section {\r\n    padding: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
